

export function getEinheitenUmrechnung(id_einheit: string, id_energietraeger: string) {
    const id = id_energietraeger + '_' + id_einheit;
    switch (id)  {
        case 'bio_hackschnitzel_srm':
            return { id: 'kg', factor: 203, name: 'kg' };
        case 'bio_brennholz_rm':
            return { id: 'kg', factor: 374.5, name: 'kg' };
        case 'erdgas_l':
            return { id: 'm3', factor: 0.25445, name: 'm³' };
        case 'fluessiggas_kg':
            return { id: 'l', factor: 1.850724, name: 'Liter' };
        case 'fluessiggas_l':
            return { id: 'kg', factor: (1 / 1.850724), name: 'kg' };
        case 'fernwaerme_mwh':
            return { id: 'kwh', factor: 1000, name: 'kWh' };
    }
    // console.log('getEinheitenUmrechnung: Schlüssel nicht gefunden: ' + id);
    return undefined;
}
